import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Store} from "@ngrx/store";
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";

interface supportTel {
  country: string;
  tel: string;
}

interface supportChannel {
  name: string;
  linkAddress: string;
}

@Component({
  selector: 'ispm-help-and-support',
  templateUrl: './help-and-support.component.html',
  styleUrls: ['./help-and-support.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class HelpAndSupportComponent implements OnInit {
  public currentApp:string = "";
  public currentOrganization:string = "";
  public mailto: string = "oncology.support@philips.com";
  public emailSubject: string = "";
  public emailMassage: string="Please provide the following details about your support request:%0A-------------------------------%0AContact Info%0AName*                  :%0AContact No.*        :%0AEmail Id.*             :%0A%0AOrganization*      : ";
  public supportTels: Array<supportTel> = [{country: "USA / Canada", tel: "(1) 855-276-6947"}];
  public supportChannels: Array<supportChannel> = [{
    name: "Philips Customer Service Portal",
    linkAddress: "https://www.customerservices.philips.com/cp_login"
  }]

  constructor(genomicsStore: Store<IgenomicsState>) {
    genomicsStore.select('navigation', 'currentApp').subscribe((app) => {
      if(app!=null)
        this.currentApp = app.name;
    });
    genomicsStore.select('users', 'organizationConfiguration').subscribe((organization) => {
      if(organization!=null)
        this.currentOrganization = organization.name;
      });
    this.emailSubject = this.currentApp==""?"S":this.currentApp+" s";
    this.emailSubject+="upport request";
    this.emailMassage+= this.currentOrganization;
    this.emailMassage+="%0AApplication*        : "+this.currentApp+"%0A-------------------------------%0ADescribe your issue or suggestion :%0A%0A%0A%0A%0AImportant Note:%0A       1. Please don’t include any sensitive information. %0A       2. A screenshot will help us better understand the issue. %0A       3. We will use details to fix problems and improve our services, subject to our Privacy Policy and Terms of Service.";
  }

  ngOnInit(): void {
  }

  philipsServiceportal(index: number) {
    window.open(this.supportChannels[index].linkAddress);
  }
}
